import {User} from "../user.model";

export class TechRadarDataHolder {
  user: User;
  skills: SkillData[];
  techRadarData: {label: string, quadrant: string, ring: number, moved: number}[];

  constructor(messageJSON: any) {
    this.user = messageJSON.user;
    this.skills = messageJSON.skills;
    this.techRadarData = messageJSON.techRadarData;
  }
}

export class SkillData {
  id: number;
  label: string;
  quadrant: string;
  level: string;
  needTraining: boolean;
  mayBeInterested: boolean;
}

export class BlipsData {
  label: string;
  quadrant: string;
  ring: number;
  moved: number;
}

export class StatData {
  skills: SkillData;
  count: number;

  constructor(messageJSON: any) {
    this.skills = messageJSON.skills;
    this.count = messageJSON.count;
  }
}
